import { useRef, useState, useEffect } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { BulletStatus } from 'components/bullet-status/bullet-status';
import { useGatewayCardContext } from '../gateway-card.context';
import { getStatusLabel } from 'features/gateways/gateway.utils';

const BlurOverlay: React.FC = () => {
    const {
        gateway: { status, admin_comment },
    } = useGatewayCardContext();

    const typographyRef = useRef<HTMLDivElement | null>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (typographyRef.current) {
                const element: any = typographyRef.current;
                setIsOverflowing(element?.scrollHeight > element?.clientHeight);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);

        return () => {
            window.removeEventListener('resize', checkOverflow);
        };
    }, [admin_comment]);
    return (
        <>
            {status && status !== 'activated' && (
                <Box
                    sx={{
                        zIndex: 5,
                        position: 'absolute',
                        top: '-6px',
                        left: '-16px',
                        right: '-16px',
                        bottom: '-16px',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 1,
                        backdropFilter: 'blur(5px)',
                    }}>
                    <BulletStatus
                        label={getStatusLabel(status)}
                        type={
                            status === 'activated'
                                ? 'success'
                                : status === 'pending'
                                  ? 'warning'
                                  : 'error'
                        }
                        icon={
                            status === 'pending' ? 'fa-light fa-spinner' : ''
                        }
                    />

                    {status === 'rejected' && admin_comment && (
                        <Tooltip
                            title={admin_comment}
                            placement="bottom"
                            arrow
                            disableHoverListener={!isOverflowing}>
                            <Typography
                                ref={typographyRef}
                                variant="body1"
                                fontSize={14}
                                sx={{
                                    color: 'error.light',
                                    backgroundColor: (theme) =>
                                        theme.app.status.errorBackground,
                                    borderRadius: 2,
                                    maxHeight: '200px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 9,
                                    WebkitBoxOrient: 'vertical',
                                    m: 3,
                                    px: 1,
                                    py: 0.3,
                                }}>
                                {admin_comment}
                            </Typography>
                        </Tooltip>
                    )}
                </Box>
            )}
        </>
    );
};

export default BlurOverlay;
